<template>
  <div>
    <div v-if="contents.length === 1" style="overflow: hidden;">
      <div class="widget-single-header-img" v-for="(content, index) in contents" :key="index">
        <div class="widget-button-header" @click="openNewTab(content.url)">
          <img v-if="content.image_url" :src="content.image_url">
          <img v-else src="../../assets/img/image_default.png">
          <div class="widget-button-header-desc" v-if="content.title">
            <div class="title">{{content.title || '' | truncate(20)}}</div>
            {{content.description || '' | truncate(40)}}
            <div class="price">
              <p class="old" v-if="content.price">{{content.price || ''}}{{content.currency || ''}}</p>
              <p v-if="content.price && content.sale_price">{{content.sale_price || ''}}{{content.currency || ''}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="multiple-buttons">
      <siema
        :options="{perPage: 1.43}"
        @update:current="changeSlide"
        ref="generic">
        <div class="button-slide-item" v-for="(content, index) in contents" :key="index">
          <div class="widget-button-header" @click="openNewTab(content.url)">
            <div class="widget-button-header-img">
              <img v-if="content.image_url" :src="content.image_url">
              <img v-else src="../../assets/img/image_default.png">
            </div>
            <div class="widget-button-header-desc" v-if="content.title">
              <div class="title">{{content.title || '' | truncate(20)}}</div>
              {{content.description || '' | truncate(40)}}
              <div class="price">
                <p class="old" v-if="content.price">{{content.price || ''}}{{content.currency || ''}}</p>
                <p v-if="content.price && content.sale_price">{{content.sale_price || ''}}{{content.currency || ''}}</p>
              </div>
            </div>
          </div>
        </div>
      </siema>
      <button :class="{disabled: currentSlide === 0}" @click="$refs.generic.prev()"><v-icon name="chevron-left" scale="1" fill="#8C8C8C"/></button>
      <button :class="{disabled: currentSlide >= contents.length - 2}" @click="$refs.generic.next()"><v-icon name="chevron-right" scale="1" fill="#8C8C8C"/></button>
    </div>
  </div>
</template>

<script>
import { Siema } from 'vue2-siema'

const objectPath = require('object-path')

export default {
  name: 'generic-template',
  props: ['generics'],
  data () {
    return {
      currentSlide: 0
    }
  },

  computed: {
    contents () {
      return this.generics.map(c => {
        c.price_sale = objectPath.get(c, 'buttons.0.title', '')
        return c
      })
    }
  },

  watch: {
    generics () {
      if (this.$refs.generic) this.$refs.generic.destroy(true, this.$refs.generic.init())
    },
  },

  components: {
    Siema
  },

  methods: {
    changeSlide (number) {
      this.currentSlide = number
    },

    openNewTab (url) {
      if (!url) return
      window.open(url, '_blank')
    }
  }
}
</script>
